<div [class.loader-hidden]="!show">
  <div class="loader-top-overlay">
    <div class="loader-overlay">
      <div *ngIf="show">
        <img class="maxWidth150" alt="loader" src="../../../assets/loader.svg">
      </div>
    </div>
  </div>
</div>
